module.exports = __webpack_public_path__ + "img/1440.351a05e4.jpg";